import { Flex } from "@eworkit/iris";
import { FieldArray } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";

import { Text } from "@/components/Text";
import { fetchCodelist, ICodelist } from "@/data/codelists";
import { Checkbox } from "@/eworkitComponents";
import { useCodelistTranslation } from "@/hooks/Codelist";
import { useFetcher } from "@/hooks/http";
import { ICodelistGenericSelectParams } from "@/views/components/Codelists";

export interface IWorkPreferencesSectionEdiProps {
  workPreferences: Array<ICodelist["code"]>;
  onChange?: () => void;
}

const WORK_PREFERENCES_CODELIST_QUERY: ICodelistGenericSelectParams = { codelistName: "work-preference" };

export const WorkPreferencesSectionEdit: React.FC<IWorkPreferencesSectionEdiProps> = React.memo(props => {
  const { workPreferences } = props;
  const { t } = useTranslation("session");
  const tCodelist = useCodelistTranslation();

  const { payload } = useFetcher(fetchCodelist, WORK_PREFERENCES_CODELIST_QUERY);
  const workPreferencesSorted = payload ? payload.sort((a, b) => (a.code > b.code ? -1 : 1)) : [];

  return (
    <Flex alignSelf="baseline" flexGrow={1} flexDirection="column" gap={"xxs"}>
      <Text size="md" color="grey1">
        {t("CONSULTANT_PROFILES.DETAIL.WORK_PREFERENCES.LABEL")}
      </Text>
      <FieldArray
        name="workPreferences"
        render={arrayHelpers => (
          <Flex gap={["xs", null, null, "lg"]} flexDirection={["column", null, null, "row"]}>
            {workPreferencesSorted.map(preference => (
              <Checkbox
                name="workPreference"
                key={preference.code}
                value={preference}
                checked={!!workPreferences.find(c => c === preference.code)}
                size="lg"
                onChange={checked => {
                  if (checked) {
                    arrayHelpers.push(preference.code);
                  } else {
                    const idx = workPreferences.findIndex(c => c === preference.code);
                    arrayHelpers.remove(idx);
                  }

                  props.onChange?.();
                }}>
                <Text size="md">{tCodelist("work-preference", preference.code)}</Text>
              </Checkbox>
            ))}
          </Flex>
        )}
      />
    </Flex>
  );
});
